import React from "react";
import { useQuery } from "@tanstack/react-query";
import { AxiosInstance } from "axios";
import { AxiosWrapper } from "services/AxiosWrapper";
import { BookingManagerApiService } from "services/BookingManagerApi";

export const useReviewPageQueries = (bookingManagerApi: BookingManagerApiService<AxiosWrapper<AxiosInstance>>, hotelUuid?: string, enabled: boolean = true) => {
  return {
    getHotelReviews: useQuery({
      queryKey: ['getHotelReviews', hotelUuid],
      queryFn: () => hotelUuid ? bookingManagerApi.getHotelReviews(hotelUuid) : null,
      enabled: enabled && !!hotelUuid,
    }),
  };
};